<template>
  <a-layout
    id="components-layout-demo-custom-trigger"
    class="my-layout my-layout-collapsed"
    theme="light"
  >
    <Header></Header>
    <a-layout-header class="layout-header" theme="light">
      <div class="com-size container">
        <!-- Logo区域 -->
        <!-- <div class="logo-wrapper">
          <router-link to="/" class="logo">
            <img src="@/assets/images/home/logo.png" alt="网站Logo" />
          </router-link>
        </div> -->
        <!-- 导航菜单 -->
        <nav class="main-nav">
          <ul class="nav-list">
            <li v-for="(item, index) in webNavList" :key="index">
              <section
                :class="{ active: curUrlName == item.strRoute || navId == item.strId }"
                @click.stop="toNav(item, item.strColumnId)"
                @mouseover="secordIndex = 0"
              >
                <img :src="getNavIcon(item)" alt="">
                {{ item.strNavigationName }}
              </section>
              <!-- 有三级菜单 -->
              <!-- 公司概况、通知公告 -->
              <div class="company-overview" v-if="item.strRoute == 'overview' || item.strRoute == 'notice'">
                <div
                  class="overview-box"
                  v-if="item.children && item.children.length"
                >
                  <div class="secord-menu">
                    <div
                      v-for="(company, ind) in item.children"
                      :key="ind"
                      class="company-list"
                      @click.stop="toNav(company, company.strColumnId)"
                      @mouseover="secordIndex = ind"
                    >
                      <div :class="{ active: ind == secordIndex }">
                        {{ company.strNavigationName }}
                      </div>
                      <ul class="third-ul" v-if="secordIndex == ind">
                        <li
                          v-for="(third, thirdInd) in company.children"
                          :key="thirdInd"
                          @click.stop="toNav(third, company.strColumnId, third.strColumnId)"
                        >
                          <span></span>
                          {{ third.strNavigationName }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <!--  -->
                </div>
              </div>
              <!-- 有二级菜单 -->
              <!-- 公司概况 -->
              <div v-else class="dropdown-menu">
                <ul
                  class="menu-box"
                  v-if="item.children && item.children.length"
                >
                  <li
                    v-for="(secord, ind) in item.children"
                    :key="ind"
                    @click.stop="toNav(secord, item.strColumnId, secord.strColumnId)"
                  >
                    {{secord.strNavigationName}}
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </a-layout-header>
    <div class="layout-container">
      <router-view :key="$route.path"></router-view>
    </div>
    <Footer v-if="!$route.meta.hideFooter"></Footer>
    <!-- 返回顶部按钮 -->
    <div
      class="back-to-top"
      @click="scrollToTop"
      v-if="!$route.meta.scrollToTop"
    >
      <img src="@/assets/images/home/top.gif" alt="" />
    </div>
  </a-layout>
</template>
<script>
// import api from '@/fetch/api'
import Header from './Header.vue'
import Footer from './Footer.vue'
import { getWebNavigation } from '@/utils/api'

export default {
  data() {
    return {
      curUrlName: 'home',
      secordIndex: 0,
      // thirdIndex: -1,
      webNavList: [],
      navId: ''
    }
  },
  components: { Header, Footer },
  computed: {},
  watch: {
    $route: {
      handler(route) {
        const name = route.query?.type ?? route.name
        this.curUrlName = name
        const item = this.webNavList.find((it) => it.strRoute == name)
        item && this.$store.commit('setBreadcrumbs', item)
        this.navId = route.query?.id
        console.log(route,name,item, 9999999)
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.getWebNavigationFn()
  },
  beforeDestroy() {},
  methods: {
    async getWebNavigationFn() {
      const { code, data } = await getWebNavigation()
      if (code == 200) {
        const talentList = ['高端人才引进', '人才创新创业', '人才数据开发', '人才综合服务', '人才融合发展'].map((item,index) => {
          return {
            strColumnId: index,
            strNavigationName: item,
            strParentId: '-1',
          }
        })
        const libraryList = ['战略咨询', '产业研究', '国资培训', '资源赋能', '人才建设', '国资论坛'].map((item,index) => {
          return {
            strColumnId: index,
            strNavigationName: item,
            strParentId: '-1',
          }
        })
        const webNavList = data.map(item => {
          if(item.strRoute == 'talent') {
            item.children = talentList
          }
          if(item.strRoute == 'library') {
            item.children = libraryList
          }
          return item
        });
        this.webNavList = this.flatNavListFn(webNavList)
        this.$store.commit('setWebNavList', this.webNavList)
        console.log(this.webNavList, 'webNavList')
      }
    },
    flatNavListFn(ary, name) {
      for (let i in ary) {
        const item = ary[i]
        item.strRoute = item.strRoute ? item.strRoute : name
        if (item.children && item.children.length) {
          this.flatNavListFn(item.children, item.strRoute)
        }
      }
      return ary
    },
    // toNav(item, parentColumnId) {
    //   console.log(item, parentColumnId,'itemitem')
    //   if (!item.strRoute) return
    //   let url = `/${item.strRoute}`
    //   if (item.strParentId != '-1') { // 二级、三级菜单
    //     // 二级公司
    //     if (item.children && item.children.length) {
    //       url = `${url}?id=${item.strColumnId}`
    //     } else {
    //       // 三级
    //       url = `${url}?id=${parentColumnId}&tabId=${item.strColumnId}`
    //     }
    //   } else {
    //     if (item.children && item.children.length) {
    //       url = `${url}?id=${item.children[0].strColumnId}`
    //     } else {
    //       url = item.strColumnId
    //       ? `${url}?id=${item.strColumnId}`
    //       : url
    //     }
    //   }
    //   if(url == this.$route.fullPath) return
    //   // return console.log(url, 'url')
    //   this.$router.push(url)
    // },
    toNav(item, columnId, tabId) {
      // console.log(item, columnId, tabId, 'itemitem')
      if (!item.strRoute) return
      let url = `/${item.strRoute}`
      let query = {
        id: columnId
      }
      // 三级菜单
      if(item.strRoute == 'overview' || item.strRoute == 'notice') {
        if(item.strParentId == '-1') {
          query.id = item.children[0].strColumnId
        } else {
          if(tabId || tabId === 0) query.tabId = tabId
        }
      } else {
        if(tabId || tabId === 0) query.tabId = tabId
      }
      // console.log(url,'urlurl')
      this.$router.push({
        path: url,
        query
      })
    },
    scrollToTop() {
      // 平滑滚动到页面顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    // 获取导航图标
    getNavIcon(item) {
      return require(`@/assets/images/nav-${item.strRoute}.png`)
    }
  },
}
</script>
<style lang="scss" scoped>
::v-deep.my-layout {
  padding-top: 155px;
  background: #fff;
  .layout-header {
    position: fixed;
    top: 95px;
    width: 100vw;
    background-color: #d80015;
    // background: linear-gradient(90deg, #d80014 0%, #e0480e 81%, #d80014 100%);
    height: 60px;
    padding: 0;
    line-height: normal;
    z-index: 99;
    .container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      .logo {
        display: flex;
      }
    }
  }
}
// 导航菜单
.main-nav {
  width: 100%;
  position: relative;
  .nav-list {
    display: flex;
    justify-content: space-between;
    list-style: none;
    margin: 0;
    padding: 0;
    // border-bottom: 1px solid #f1f1f1;
    position: relative;
    > li {
      // margin-left: 32px;
      flex: 1;
      position: relative;
      &:first-of-type {
        // margin-left: 12px;
      }
      &:hover {
        .company-overview {
          display: flex;
        }
        .dropdown-menu {
          display: block;
        }
        > section {
          background-color: #b30506;
        }
      }

      > section {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 16px;
        font-weight: 500;
        text-decoration: none;
        transition: color 0.3s ease;
        font-weight: 400;
        font-size: 20px;
        height: 60px;
        color: #fff;
        position: relative;
        // line-height: 70px;
        img {
          margin-right: 5px;
        }
        &.active {
          // font-weight: bold;
          // font-size: 16px;
          // color: #da1413;
          background-color: #b30506;
          // &::after {
          //   content: '';
          //   position: absolute;
          //   bottom: 0;
          //   left: 0;
          //   width: 100%;
          //   height: 3px;
          //   background-color: #da1413;
          // }
        }
      }
    }
  }
}
.company-overview {
  top: 56px;
  position: absolute;
  left: 0;
  padding-top: 5px;
  background: transparent;
  display: none;
  z-index: 99;
  right: 0;
  width: 450px;
  .overview-box {
    background: #ffffff;
    display: flex;
    width: 100%;
    // width: 730px;
    height: 200px;
    border-radius: 0px 0px 4px 4px;
  }
  .secord-menu {
    width: 291px;
    height: 200px;
    background: #fdf7ec;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    .company-list div {
      width: 240px;
      text-align: center;
      padding: 9px 0;
      // line-height: 44px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #da1413;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      cursor: pointer;
      margin: 8px 0;
      &:hover,
      &.active {
        background: #da1413;
        color: #fff;
      }
    }
  }
  .third-ul {
    position: absolute;
    width: 160px;
    height: 200px;
    padding-left: 30px;
    left: 100%;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    li {
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      margin-bottom: 25px;
      cursor: pointer;
      &:hover,
      &.active {
        color: #da1413;
        span {
          background: #da1413;
        }
      }
      &:last-of-type {
        margin-bottom: 0;
      }
      span {
        display: inline-block;
        width: 6px;
        height: 6px;
        background: #aaaaaa;
        border-radius: 50%;
        margin-right: 5px;
        vertical-align: middle;
      }
    }
    img {
      width: 200px;
      height: 152px;
    }
  }
}
.dropdown-menu {
  top: 55px;
  position: absolute;
  left: 0;
  padding-top: 5px;
  background: transparent;
  display: none;
  z-index: 99;
  right: 0;
  width: 100%;
  .menu-box {
    background: #d80015;
    width: 100%;
    border-radius: 0px 0px 4px 4px;
    > li {
      color: #fff;
      text-align: center;
      padding: 15px 0;
      border-bottom: 1px solid rgba(255, 255, 255,0.3);
      cursor: pointer;
      &:last-of-type {
        border-bottom: none;
      }
      &:hover {
        background: #b30506;
      }
    }
  }
}
// 返回顶部按钮
.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 10px;
  // width: 45px;
  // height: 45px;
  z-index: 99;
  img {
    cursor: pointer;
    border-radius: 4px;
  }
}
</style>
